import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../BaseModule/Components/BaseModal/BaseModal';
import Button from '../../../BaseModule/Components/Button';
import { Size } from '../../../../Enums/Size.enum';
import LinkButton from '../../../BaseModule/Components/Button/LinkButton/LinkButton';
import styles from './SubscriptionCancellationModal.module.scss';
import Text from '../../../BaseModule/Components/Text';

interface Props extends BaseModalProps {
	onCancelSubscription: () => void;
}

const SubscriptionCancellationModal: React.FC<Props> = props => (
	<BaseModal
		{...props}
		title='component.subscriptionCancellationModal.title'
		size={Size.SM}
	>
		<div className={styles.wrapper}>
			<div className='d-flex flex-column justify-content-center align-items-center gap-4'>
				<Text tx='component.subscriptionCancellationModal.text' />
				<Button
					text='component.subscriptionCancellationModal.cancel'
					onClick={props.onClose}
				/>
				<LinkButton
					text='component.subscriptionCancellationModal.confirm'
					theme='purple'
					onClick={props.onCancelSubscription}
				/>
			</div>
		</div>
	</BaseModal>
);
export default SubscriptionCancellationModal;
